import {VGMap, VGMap3} from "../../../../../modules/index.esm";

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');

	if ($maps.length) {
		if (App.yaMapVersion === 'v3') {
			for (let $map of $maps) {
				VGMap3.init($map);
			}
		} else if (App.yaMapVersion === '2.1') {
			for (let $map of $maps) {
				VGMap.init($map);
			}

			// локация пользователя
			if (('location' in App) && App.location) {
				VGMap.Location.init(function (data) {
					VGMapLocation.set(data)
				});
			}

			/*VGMap.init('yaMapStores', {
				callback: {
					afterInitMap: function (map, params, _this) {
						VGMapCustom.run(map, params, _this);
					}
				}
			})*/
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

const VGMapCustom = {
	run: function (map, params, self) {
		// Карта инициализирована, все параметры получены. Дальше ебитесь сами!
		params.marker.color = 'red'
		self.PlaceMark.set(map, params);
	},
}

const VGMapLocation = {
	city: App.city || "Москва",
	coordinates: null,
	cities: App.cities || [],
	containers: [],
	isConfirmed: false,

	set: function (data) {
		let _this = this;

		_this = Object.assign({}, _this, data);
		_this.city = _this.geoObjects.get(0).getLocalities().join('');
		_this.coordinates = _this.geoObjects.get(0).geometry.getCoordinates();

		_this.containers.push(document.querySelectorAll('[data-location-city]') || null)
		document.body.setAttribute('data-location-confirm', 'false');

		let $containers = _this.containers,
			isConfirmed = document.body.dataset.locationConfirm || null;

		_this.isConfirmed = isConfirmed !== 'false';

		for (let containers of $containers) {
			for (const $container of containers) {
				$container.innerText = _this.city;

				if (!this.isConfirmed) {
					let spanElement = document.createElement('span');
					spanElement.classList.add('location-confirmed');
					spanElement.innerText = '?';

					$container.append(spanElement);
				}
			}
		}
	}
}
